import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { Box, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import TableApproveList from "./tableApproveList";
import { useTranslation } from "react-i18next";

import {
  updateApproveLeaveEmployeeBy,
  getAllLeaveWithDrawBy,
  approveRequestLeaveByManager,
  getManagerPendingRequestLeave,
} from "../../../../actions/leave";
import { getLeaveRequest } from "../../../../actions/employee";

import DialogCommentReject from "./DialogCommentReject";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from '@mui/icons-material/Delete';

import ButtonBlue from "../../shared/general/ButtonBlue";
import AlertResponse from "../../shared/general/AlertResponse";
import CardRequest from "./CardRequest";
import { openNotificationAlert } from "../../../../actions/notificationAlert";

const StyledBoxWrapApprove = styled("div")({
  marginBottom: 16,
  "& .wrap-btn": {
    display: "flex",
    justifyContent: "flex-end",
  },
  ["@media only screen and (max-width:600px)"]: {
    "& .wrap-btn": {
      display: "flex",
      justifyContent: "space-around",
      paddingTop: "24px"
    },
  },
});

const StyledNotApprove = styled(Button)({
  color: "#ffffff",
  backgroundColor: "#d32f2f",
  borderColor: "#d32f2f",
  borderRadius: 8,
  "&:hover": {
    backgroundColor: "#c62828",
    borderColor: "#c62828",
  },
});

const StyledButtonCancel = styled(ButtonBlue)({
  // backgroundColor:"#D32F2F",
  borderRadius: "8px",
  border: "1px solid #D32F2F",
  color: "#D32F2F",
  marginRight: 8,
  width: 130,
  "&:hover": {
    backgroundColor: "#FCF1F1"
  }
});

function TableApproval(props) {
  const { searchName, searchDate, setNumberOfList } = props;
  const dispatch = useDispatch();
  const mobileResponsive = useMediaQuery('(max-width:600px)');
  // const { result: leaveEmployeesList } = useSelector(
  //   (state) => state.leaveEmployees
  // );
  // const { result: leaveEmployeeWithdrawsList } = useSelector(
  //   (state) => state.leaveEmployeesWithDraw
  // );

  const { result: managerId } = useSelector((state) => state.managerId);
  const { result: managerPendingRequestLeave } = useSelector(state => state.managerPendingRequestLeave);

  const [approvalSelected, setApprovalSelected] = useState([]);
  const [pendingRows, setPendingRows] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertType, setAlertType] = useState(false);
  const [openDialogReject, setOpenDialogReject] = useState(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if(managerPendingRequestLeave){
      let pendingList = managerPendingRequestLeave.sort(function (a, b) {
        return new Date(b.createDate) - new Date(a.createDate);
      });
      setPendingRows(pendingList);
      setNumberOfList(pendingList.length);
    }
  }, [managerPendingRequestLeave])

  const handleApprovalRequest = async (approve, comment) => {
    let managerIdList = managerId.map((x) => x.idManagerEmployee);

    const idLeaveLV1 = approvalSelected.filter(item => {
      return (!item.idLeaveEmployeesWithdraw && item.isManagerLV1Approve === null && (item.isDoubleApproval === 1 || (item.isDoubleApproval === 0 && item.approvalLevel === 1)))
        && (managerIdList.includes(item.managerLV1ApproveBy))
    }).map(item => item.idLeave);

    const idLeaveLV2 = approvalSelected.filter(item => {
      return (!item.idLeaveEmployeesWithdraw && item.isManagerLV2Approve === null && (item.isDoubleApproval === 1 || (item.isDoubleApproval === 0 && item.approvalLevel === 2)))
        && (managerIdList.includes(item.managerLV2ApproveBy))
    }).map(item => item.idLeave)

    const leaveEmployeeWithdraw = approvalSelected.filter(item => {
      return (item.idLeaveEmployeesWithdraw && item.isApprove === null && managerIdList.includes(item.managerApprove));
    })

    const idLeaveEmployeesWithdraw = leaveEmployeeWithdraw.map(item => item.idLeaveEmployeesWithdraw);
    const idLeaveWithdraw = leaveEmployeeWithdraw.map(item => item.idLeave);

    const formData = [
      {
        idLeaveLV1: idLeaveLV1,
        isManagerLV1Approve: approve,
        // managerLV1ApproveBy: userProfile.idEmployees,
        managerLV1ApproveDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        managerLV1Comment: comment? comment : null,
      },
      {
        idLeaveLV2: idLeaveLV2,
        isManagerLV2Approve: approve,
        // managerLV2ApproveBy: userProfile.idEmployees,
        managerLV2ApproveDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        managerLV2Comment: comment? comment : null,
      },
      {
        idLeaveEmployeesWithdraw: idLeaveEmployeesWithdraw,
        idLeave: idLeaveWithdraw,
        isApprove: approve,
        approveDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        commentManager: comment? comment : null,
      },
    ];

    const result = await dispatch(approveRequestLeaveByManager(formData));

    if (result && result.status === 200) {
      dispatch(openNotificationAlert({
        type: "success",
        message: t("DataSaveSuccessful"),
      }));
      setApprovalSelected([]);
      dispatch(getManagerPendingRequestLeave());
    } else {
      dispatch(openNotificationAlert({
        type: "error",
        message: t("AnErrorOccurred")
      }));
    }
    setOpenDialogReject(false);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleClickAll = () => {
    setApprovalSelected(pendingRows);
  };

  const handleCancel = () => {
    setApprovalSelected([]);
  };

  return (
    <Box>
      <StyledBoxWrapApprove>
        {mobileResponsive && (
          <Box display="flex" justifyContent="flex-end">
            {(approvalSelected.length > 0) &&
              <StyledButtonCancel
                startIcon={<DeleteIcon />}
                onClick={handleCancel}
              >
                {`ยกเลิก`}
              </StyledButtonCancel>
            }
            {!(approvalSelected.length === pendingRows.length) &&
              <ButtonBlue
                startIcon={<DoneAllIcon />}
                variant="outlined"
                onClick={handleClickAll}
              >
                {`เลือกทั้งหมด`}
              </ButtonBlue>
            }
          </Box>
        )}
        {approvalSelected.length > 0 &&
          <div className="wrap-btn">
            <ButtonBlue
              style={{ marginRight: 8 }}
              startIcon={<DoneAllIcon />}
              variant="contained"
              onClick={() => handleApprovalRequest(1)}
            >
              {`${t("Approve")} ${approvalSelected.length > 0
                  ? `${approvalSelected.length} ${t("Items")}`
                  : ""
                }`}
            </ButtonBlue>
            <StyledNotApprove
              startIcon={<CloseIcon />}
              variant="outlined"
              onClick={() => setOpenDialogReject(true)}
            >
              {`${t("Disapproval")} ${approvalSelected.length > 0
                  ? `${approvalSelected.length} ${t("Items")}`
                  : ""
                }`}
            </StyledNotApprove>
          </div>
        }
      </StyledBoxWrapApprove>
      {openDialogReject && (
        <DialogCommentReject
          open={openDialogReject}
          onClose={() => setOpenDialogReject(false)}
          handleSubmit={(comment) => {
            handleApprovalRequest(0, comment);
          }}
        />
      )}
      {!mobileResponsive ?
        <TableApproveList
          checkbox={true}
          // dataTable={
          //   leaveEmployeesList && leaveEmployeeWithdrawsList
          //     ? pendingRows
          //     : []
          // }
          dataTable={managerPendingRequestLeave? pendingRows: []}
          isLeave={true}
          approvalSelected={approvalSelected}
          setApprovalSelected={setApprovalSelected}
          searchName={searchName}
          setNumberOfList={setNumberOfList}
        />
        :
        <div>
          {(pendingRows && pendingRows.length > 0) ?
            pendingRows.map(row => (
              <CardRequest
                row={row}
                selectedRows={approvalSelected}
                setSelectedRows={setApprovalSelected}
              />
            ))
            :
            <div>
              <Typography align="center">{t("No_Data")}</Typography>
            </div>
          }
        </div>
      }

      <AlertResponse
        open={openAlert}
        handleClose={handleCloseAlert}
        alertType={alertType}
      />
    </Box>
  );
}

export default TableApproval;
